// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"inputColor_inputContainer__2aOEh","hexLabel":"inputColor_hexLabel__36tY4"};